import axios from 'axios';
import { Station, TrainData } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const getStations = async (): Promise<Station[]> => {
  const response = await axios.get(`${API_BASE_URL}/stations`);
  // The stationName can be full of junk, so we'll clean it up
  return response.data.map((s: any) => ({
    ...s,
    stationName: s.stationName.replace(/\[[A-Z0-9]+\]/g, '').trim(),
  })).filter((s: Station) => s.crsCode && s.stationName);
};

export const getNearbyTrains = async (
  lat: number,
  lon: number,
  favourites: Station[],
  scenarioName?: string,
  timeSavedThreshold?: number
): Promise<TrainData> => {
  const favouriteCrsCodes = favourites.map(station => station.crsCode);
  const headers = scenarioName ? { 'X-DWMT-Record-Scenario': scenarioName } : {};
  const params: Record<string, string | number> = {
    lat,
    lon,
    favourites: favouriteCrsCodes.join(','),
  };
  if (timeSavedThreshold !== undefined) {
    params['time-saved-threshold'] = timeSavedThreshold;
  }
  const response = await axios.get(`${API_BASE_URL}/nearby-trains`, {
    params,
    headers
  });
  return response.data;
};

export const getTrainsByCrs = async (
  crsCode: string,
  favourites: Station[],
  scenarioName?: string,
  timeSavedThreshold?: number
): Promise<TrainData> => {

  const favouriteCrsCodes = favourites.map(station => station.crsCode);
  const headers = scenarioName ? { 'X-DWMT-Record-Scenario': scenarioName } : {};
  const params: Record<string, string | number> = {
    favourites: favouriteCrsCodes.join(','),
  };
  if (timeSavedThreshold !== undefined) {
    params['time-saved-threshold'] = timeSavedThreshold;
  }
  const response = await axios.get(`${API_BASE_URL}/trains/from/${crsCode}`, {
    params,
    headers
  });
  return response.data;
};

export const getStationByCrs = async (crsCode: string): Promise<Station> => {
  const response = await axios.get(`${API_BASE_URL}/station/${crsCode}`);
  return response.data;
};
